import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../../services/authApi";

import "../styles/auth.css";

export default function OnboardingPassword() {
  const nav = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const sessionToken =
    sessionStorage.getItem("onb_sessionToken") || "";

  const submit = async () => {
    if (!sessionToken) {
      return alert(
        "Missing session. Go back to onboarding start."
      );
    }

    if (!password) {
      return alert("Enter password");
    }

    if (password.length < 8) {
      return alert(
        "Password must be at least 8 characters"
      );
    }

    if (password !== confirmPassword) {
      return alert("Passwords do not match");
    }

    const profile = JSON.parse(
      sessionStorage.getItem("onb_profile") || "{}"
    );

    const fullName = `${profile.firstName || ""} ${
      profile.lastName || ""
    }`.trim();

    setLoading(true);

    try {
      await authApi.createPassword(
        password,
        sessionToken,
        fullName
      );

      nav("/onboarding/profile");
    } catch (e: any) {
      alert(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrap">
      <div className="auth-topbar">
        <div
          style={{
            fontWeight: 800,
            color: "#174350",
          }}
        >
          QAVACH
        </div>

        <div style={{ color: "#777" }}>
          Step 2/3
        </div>
      </div>

      <div className="auth-accent">
        Create Account Password
      </div>

      <div className="auth-card">
        <h2 className="auth-title">
          Set Password
        </h2>

        <p className="auth-sub">
          Create a secure password for your
          account.
        </p>

        <input
          className="auth-input"
          value={password}
          onChange={(e) =>
            setPassword(e.target.value)
          }
          placeholder="Password"
          type="password"
        />

        <input
          className="auth-input"
          value={confirmPassword}
          onChange={(e) =>
            setConfirmPassword(
              e.target.value
            )
          }
          placeholder="Confirm Password"
          type="password"
        />

        <div className="auth-row">
          <button
            className="auth-btn secondary"
            disabled={loading}
            onClick={() =>
              nav("/onboarding/phone")
            }
          >
            Back
          </button>

          <button
            className="auth-btn"
            disabled={loading}
            onClick={submit}
          >
            {loading
              ? "Saving..."
              : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
}